// The locale an amount is written in: the language of the signed in user (hu when there is none yet, as it was before the
// user's language was followed).
export function moneyLocale(languageCode) {
  return languageCode || "hu";
}

// An amount with its currency as the lists show it (HUF without fractions); `signed` puts a + in front of a gain. A locale
// Intl does not know falls back to hu.
export function formatAmount(amount, currency, locale, signed = false) {
  if (amount === null || amount === undefined || amount === "" || !currency) {
    return "-";
  }

  const options = {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: currency === "HUF" ? 0 : 2,
  };
  let text;
  try {
    text = Number(amount).toLocaleString(locale, options);
  } catch (e) {
    text = Number(amount).toLocaleString("hu", options);
  }

  return signed && Number(amount) > 0 ? `+${text}` : text;
}
